export const CALENDAR_FIELD_STYLES =
  'body-text rounded-md border bg-grey-950 border-grey-800 px-3 py-2 text-grey-100 ' +
  'transition-colors duration-150 focus:border-primary-50 focus:ring-3 focus:ring-primary-50/12';

export const CALENDAR_OUTLINE_BUTTON =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-primary-t-700 ' +
  'px-3 py-2 body-text-sb text-primary-50 transition-colors cursor-pointer ' +
  'hover:bg-primary-t-900 hover:border-primary-t-600 focus-visible:outline-none ' +
  'focus-visible:ring-3 focus-visible:ring-primary-50/12 disabled:cursor-not-allowed disabled:opacity-50';

export const CALENDAR_PRIMARY_BUTTON =
  'inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-50 px-3 py-2 ' +
  'body-text-sb text-white transition-colors cursor-pointer hover:bg-primary-100 ' +
  'focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary-50/12 ' +
  'disabled:cursor-not-allowed disabled:opacity-50';

export const CALENDAR_ICON_BUTTON =
  'rounded-full p-1.5 text-grey-400 transition-colors cursor-pointer hover:bg-grey-900 ' +
  'hover:text-grey-100 focus-visible:outline-none focus-visible:ring-3 ' +
  'focus-visible:ring-primary-50/12 disabled:cursor-not-allowed disabled:opacity-50';

export const CALENDAR_ICON_TEXT_BUTTON =
  'inline-flex min-w-0 items-start gap-1 rounded px-2 py-1.5 text-left text-xs text-primary-50 ' +
  'cursor-pointer enabled:hover:bg-white focus-visible:outline-none focus-visible:ring-3 ' +
  'focus-visible:ring-primary-50/12 disabled:cursor-not-allowed disabled:opacity-50';

export const CALENDAR_BADGE_BASE =
  'inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset';
